export default __webpack_public_path__ + "static/dominic-c91e67add79964380ae9c911a06bd2f9.jpg";